export default function (props: any) {
    // 13 * 13  #2673FF
    return (
        <svg width="1em" height="1em" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h13v13H0z" />
                <path
                    d="M7.458 6.5 4.18 9.902a.632.632 0 0 0-.181.455c0 .179.06.33.18.456.121.125.267.187.44.187a.586.586 0 0 0 .438-.188L8.8 6.93c.275-.286.266-.58-.026-.884L5.058 2.187A.586.586 0 0 0 4.619 2a.586.586 0 0 0-.438.187.632.632 0 0 0-.181.456c0 .178.06.33.18.455L7.459 6.5z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}
